export default __webpack_public_path__ + "static/media/avatar-5.b51c3119.png";